import(/* webpackMode: "eager" */ "/vercel/path0/src/app/rupiqa/partner/reset/page.tsx");
